import React, { Component } from 'react';
import { Chevron } from '@jutro/components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
//import { renderContentFromMetadata } from '@jutro/uiconfig';
import { MetadataContent } from '@jutro/uiconfig';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import policyBillingStyles from './Billing.module.scss';
import metadata from './Billing.metadata.json5';
import messages from './Billing.messages';

class PolicyBilling extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        accountNumber: PropTypes.string
                    })
                })
            }),
            billingData: PropTypes.shape({})
        }).isRequired,
        intl: PropTypes.func.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired
    };

    state = {
        billingData: [],
        currentBillingData: {},
        billingInvoiceData: [],
        policyPeriodDropDownOptions: [],
        selectedPeriod: '',
        isBillingInfoAvailable: true,
        isDirectBill: true,
        basePath: ''
    };

    componentDidMount = () => {
        this.getPolicyBillingSummaryInfo();
    };

    getPolicyBillingSummaryInfo = () => {
        const { fromAccountLanding } = this.props;

        const billingInfo = _.get(fromAccountLanding, 'billingData');
        const billingData = _.get(billingInfo, 'policyPeriodBillingSummaries');
        const basePath = _.get(fromAccountLanding, 'basePath');
        this.setState({ basePath: basePath });

        if (!_.isEmpty(billingInfo) && billingData.length > 0) {
            const invoiceData = billingData[0].invoices;
            const paymentScheduleDataTable = this.getPaymentScheduleDataTable(invoiceData);

            this.setState({
                billingData: billingData,
                billingInvoiceData: paymentScheduleDataTable,
                currentBillingData: billingData[0],
                policyPeriodDropDownOptions: this.getPolicyPeriodDropDownOptions(billingData),
                selectedPeriod: billingData[0].periodName,
                isDirectBill: billingData[0].billingMethod === 'DirectBill'
            });
        } else {
            this.setState({ isBillingInfoAvailable: false });
        }
    };

    onEditInvoiceDeliveryLinkClick = () => {
        const { history } = this.props;

        // basePath is extracted from the fromAccountLanding
        const { basePath } = this.state;
        const redirectPath = basePath.includes('/ri-billing')
            ? `${basePath}/summary`
            : `${basePath}/billing`;

        return history.push({
            pathname: '/ri-notifications',
            redirectPath: redirectPath
        });
    };

    getPaymentScheduleDataTable = (invoiceData) => {
        let invoiceArrayResult = [];

        invoiceArrayResult = invoiceData.filter((data) => {
            return parseInt(data.amount.amount) >= 0;
        }).map((data) => {
            const objData = {
                dueDate: this.getFormattedDate(data.dueDate),
                invoiceDate: this.getFormattedDate(data.invoiceDate),
                paidStatus: data.paidStatus,
                status: data.status,
                invoiceAmount: data.amount,
                outStanding: data.unpaid,
                statementAmount: data.amount
            };
            return objData;
        });
        return invoiceArrayResult;
    };

    getBillingStatus = (isDelinquent) => {
        const translator = this.context;
        if (isDelinquent) {
            return translator(messages.delinquentLabel);
        }
        return translator(messages.inGoodStandingLabel);
    };

    getBillingStatusClassName(isDelinquent) {
        let className = '';
        if (isDelinquent) {
            className = policyBillingStyles.negativePastDueAlert;
        }
        return className;
    }

    getCell = (items, index, property) => {
        const translator = this.context;
        const tooltipMessage = {
            dueDate: translator(messages.dueDateLabel),
            paidStatus: translator(messages.paidStatusLabel)
        };
        let showPastDueAlert = false;
        if (
            moment().isAfter(items.dueDate)
            && items.outStanding.amount > 0
            && property.id === 'paidStatus'
        ) {
            // eslint-disable-next-line no-param-reassign
            items.paidStatus = translator(messages.pastDue);
            showPastDueAlert = true;
        }

        const classNameShowPastDueAlert = classNames({
            [policyBillingStyles.negativePastDueAlert]: showPastDueAlert
        });

        return (
            <span title={tooltipMessage[property.id]} className={classNameShowPastDueAlert}>
                {items[property.id]}
            </span>
        );
    };

    getFormattedCurrency = (item, index, property) => {
        const translator = this.context;
        const tooltipMessage = {
            paid: translator(messages.PaidLabel),
            outStanding: translator(messages.outstandingLabel),
            statementAmount: translator(messages.statementAmountLabel)
        };

        return (
            <span
                title={tooltipMessage[property.id]}
            >
                <CurrencyField
                    id={`currency_${index}`}
                    value={item[property.id]}
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        const d = date === undefined ? ''
            : intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
        return d;
    };

    getPolicyPeriodDropDownOptions = (billingData) => {
        const translator = this.context;
        if (_.isEmpty(billingData)) {
            return null;
        }
        const now = moment();
        let currentPolicyPeriodBillingSummary;
        return billingData.map((key, index) => {
            let policyPeriodName = `${index + 1}: ${key.periodName}`;
            if (
                !currentPolicyPeriodBillingSummary
                && key.effectiveDate
                && now.isAfter(key.effectiveDate)
                && key.expirationDate
                && now.isBefore(key.expirationDate)
            ) {
                currentPolicyPeriodBillingSummary = key;
                policyPeriodName = `${policyPeriodName}`;
            }
            return {
                code: key.periodName,
                name: policyPeriodName
            };
        });
    };

    handlePolicyPeriodChange = (policyPeriod) => {
        const { billingData } = this.state;
        const policyChangeData = billingData.find((data) => data.periodName === policyPeriod);
        const invoiceData = policyChangeData.invoices;
        const paymentScheduleDataTable = this.getPaymentScheduleDataTable(invoiceData);
        this.setState({
            billingInvoiceData: paymentScheduleDataTable,
            currentBillingData: policyChangeData,
            selectedPeriod: policyPeriod
        });
    };

    getPolicyStatusIcon = (billingData) => {
        if (billingData.isDelinquent) {
            return 'mi-warning';
        }
        return 'mi-check';
    };

    getPolicyStatusClassname = (billingData) => {
        if (billingData.isDelinquent) {
            return 'policy-billing-icon policy-billing-delinquent';
        }
        return 'policy-billing-icon policy-billing-good-standing';
    };

    handleViewAccountBilling = () => {
        const {
            history,
            fromAccountLanding: {
                policyDetailsData: { policyResponse }
            }
        } = this.props;
        const {
            account: { accountNumber }
        } = policyResponse;
        const nextPath = `/accounts/${accountNumber}/billingAndPayment`;
        history.push({ pathname: nextPath, accountDetailsData: { accountNumber: accountNumber } });
    };

    getHeaderSection = (title) => {
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" />
                <h2 className={`${policyBillingStyles.title} ${policyBillingStyles.gwOverrideDefaultMargin}`}>{title}</h2>
            </React.Fragment>
        );
    };

    render() {
        const {
            billingInvoiceData,
            currentBillingData,
            policyPeriodDropDownOptions,
            selectedPeriod,
            isBillingInfoAvailable,
            isDirectBill,
        } = this.state;
        const translator = this.context;

        const showPastDueLine = currentBillingData.aggregatedPastDueAmount
            && currentBillingData.aggregatedPastDueAmount.amount > 0;
        const showCurrentPaymentLine = currentBillingData.nextDueAmount
            && currentBillingData.nextDueAmount.amount > 0;

        const overrides = {
            billingPagePolicyStatusIcon: {
                icon: this.getPolicyStatusIcon(currentBillingData),
                className: this.getPolicyStatusClassname(currentBillingData)
            },
            tabBillingSummaryTotalPremium: {
                value: currentBillingData.totalPremium
            },
            tabBillingSummaryTaxesAndFees: {
                value: currentBillingData.taxesAndFees
            },
            tabBillingSummaryTotalCosts: {
                value: currentBillingData.totalCost
            },
            billingPagePolicyBillingStatus: {
                value: this.getBillingStatus(currentBillingData.isDelinquent),
                className: this.getBillingStatusClassName(currentBillingData.isDelinquent)
            },
            tabBillingSummaryPastDueContainer: {
                visible: showPastDueLine
            },
            tabBillingSummaryPastDue: {
                value: currentBillingData.aggregatedPastDueAmount
            },
            tabBillingSummaryPastDueDate: {
                content: this.getFormattedDate(currentBillingData.pastDueDate)
            },
            tabBillingSummaryNextPaymentContainer: {
                visible: showCurrentPaymentLine
            },
            tabBillingSummaryTotalDue: {
                value: currentBillingData.accountBalance_Ext
            },
            tabBillingSummaryDueDate: {
                value: _.get(currentBillingData, 'accountBalance_Ext.amount') > 0 ? this.getFormattedDate(currentBillingData.dueDate_Ext) : ''
            },
            tabBillingSummaryMinimumDue: {
                value: currentBillingData.amountDue_Ext
            },
            tabBillingSummaryInvoiceBy: {
                value: currentBillingData.sendInvoicesBy_Ext
            },
            tabBillingSummaryPaymentMethod: {
                value: currentBillingData.paymentMethod_Ext
            },
            tabBillingSummaryBillingMethod: {
                value: translator({
                    id: `typekey.BillingMethod.${currentBillingData.billingMethod}`,
                    defaultMessage: `typekey.BillingMethod.${currentBillingData.billingMethod}`
                })
            },
            tabBillingSummaryPaymentPlanType:{
                value: translator({
                    id: `typekey.PaymentMethod.${currentBillingData.paymentPlanType}`,
                    defaultMessage: `typekey.PaymentMethod.${currentBillingData.paymentPlanType}`
                })
            },
            tabBillingSummaryPaymentPlan: {
                value: currentBillingData.paymentPlan
            },
            paymentScheduledTable: {
                data: billingInvoiceData
            },
            policyPeriodDropDown: {
                availableValues: policyPeriodDropDownOptions,
                value: selectedPeriod
            },
            billingInfoContainer: {
                visible: isBillingInfoAvailable && isDirectBill
            },
            billingEmptyContainer: {
                visible: !isBillingInfoAvailable || !isDirectBill
            },
            warningMessage: {
                value: isDirectBill ? translator(messages.noBillingDataLabel) : translator(messages.agencyBillDataLabel)
            },
            coveragesSectionContainer: {
                visible: true
            },
            coveragesSection: {
                header: this.getHeaderSection(translator(messages.paymentScheduleLabel))
            }
        };
        const resolvers = {
            resolveClassNameMap: policyBillingStyles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getFormattedCurrency: this.getFormattedCurrency,
                handlePolicyPeriodChange: this.handlePolicyPeriodChange,
                handleViewAccountBilling: this.handleViewAccountBilling,
                onEditInvoiceDeliveryLinkClick: this.onEditInvoiceDeliveryLinkClick
            }
        };

        //const policyPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
        const policyPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );

        return <div className={policyBillingStyles.policybilling}>{policyPage}</div>;
    }
}

export const BillingComponent = PolicyBilling;
export default withIntl(withAuthenticationContext(PolicyBilling));
